import { ReactElement } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';

interface PublicRouteProps {
  children: ReactElement;
}

const PublicRoute = ({ children } : PublicRouteProps) => {
    const user = useAuthStore((state) => state.data);
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();

    if (user?._id && user?.mobile) {
        const redirect = searchParams.get('redirect');
        const url = redirect || '/';

        return <Navigate to={url} />;
    } if (pathname === '/login' && user?._id && !user?.mobile) {
        return <Navigate to="/signup" />;
    }
    return children;
};

export { PublicRoute };
